
import React, { useState, useEffect, useRef } from "react";
import { Button, Card, Row, Col, Table, Modal, Form, Dropdown } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from "../../../constant";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import Select from "react-select";

const OrderList = () => {
  const tableHeaders = [
    "#",
    "Bill Number",
    "Customer Name",
    "Payment Mode",
    "Total Items",
    "Total Qty",
    "Grand Total",
    "Status",
    "Action",
  ];

  const [showPDFView, setShowPDFView] = useState(false);
  const [adjustmentData, setAdjustmentData] = useState(null);
  const rightSectionRef = useRef(null);

  const [adjustments, setAdjustments] = useState([]);
  const [showStage, setShowStage] = useState("empty");
  const [showComment, setShowComment] = useState(false);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [showAdjustDetails, setShowAdjustDetails] = useState(false);
  const [adjustmentList, setAdjustmentList] = useState([]);

  const [isEditMode, setIsEditMode] = useState(false);
  const [editOrderId, setEditOrderId] = useState(null);
  const [editOrderStatus, setEditOrderStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const navigate = useNavigate();
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [productData, setProductData] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  
  const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("name");
  const warehouseId = localStorage.getItem("warehouse_id");
  const warehouseEmail = localStorage.getItem("warehouse_email");
  const warehouseName = localStorage.getItem("warehouse_name");
  const warehouseAddress = localStorage.getItem("warehouse_full_address");

  const [showModal, setShowModal] = useState(false);

  const [customerData, setCustomerData] = useState([]);
  const [paymodeData, setPaymodeData] = useState([]);

  const [showEmailComposer, setShowEmailComposer] = useState(false);
  const [selectedAdjustment, setSelectedAdjustment] = useState(null);
  const [sendingEmail, setSendingEmail] = useState(false);

  const [formData, setFormData] = useState({
    bill_number: "",
    customer_id: "",
    customer_name: "",
    payment_mode: "",
    total_items: 0,
    total_qty: 0,
    sub_total: 0,
    discount_amount: 0,
    tax_amount: 0,
    grand_total: 0,
    payment_status: 1,
    customer_notes: "",
    terms_and_conditions: "",
    attached_file: null,
  });

  const [itemList, setItemList] = useState([]);

  const [emailData, setEmailData] = useState({
    from: warehouseEmail || "",
    to: "",
    subject: "Sales Order from Veemart POS",
    body: "",
  });

  useEffect(() => {
    fetchCustomerData();
    fetchPaymodeData();
    fetchAdjustments();
  }, []);

  const fetchCustomerData = async () => {
    try {
      const res = await axios.get(`${var_api}veemart_instore_customers/get`);
      setCustomerData(res.data || []);
    } catch {
      toast.error("Failed to fetch customer data");
    }
  };

  const fetchPaymodeData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${var_api}paymode_master/get`);
      setPaymodeData(res.data || []);
    } catch (error) {
      toast.error("Failed to fetch payment mode data");
    } finally {
      setLoading(false);
    }
  };

  const paymodeOptions = paymodeData.map((item) => ({
    value: item.paymode_name,
    label: item.paymode_name,
  }));

  const customerOptions = customerData.map((cust) => ({
    value: cust.id,
    label: cust.customer_name,
  }));

  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const allProducts = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];
      setProductData(allProducts);
    } catch (err) {
      toast.error("Failed to fetch product data");
    }
  };

  const fetchAdjustments = async () => {
    try {
      setInitialLoading(true);
      const currentWarehouseId = warehouseId || 1;
      const res = await axios.get(`${var_api}veemart_instore_pos_billing/getbywarehouse/${currentWarehouseId}`);
      setAdjustments(res.data || []);
      if ((res.data || []).length > 0) setShowStage("table");
    } catch (err) {
      console.error("Error fetching adjustments", err);
    } finally {
      setInitialLoading(false);
    }
  };

  const handleBulkAdd = () => {
    fetchProductData();
    setShowBulkModal(true);
  };

  const toggleProductSelect = (product) => {
    const exists = selectedProducts.find((p) => p.id === product.id);
    if (exists) {
      setSelectedProducts(selectedProducts.filter((p) => p.id !== product.id));
    } else {
      setSelectedProducts([
        ...selectedProducts,
        {
          id: product.id,
          product_id: product.id,
          product_name: product.product_name,
          unit_price: product.selling_price || 100,
          qty: 1,
        },
      ]);
    }
  };

  const updateQty = (id, action) => {
    setSelectedProducts((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, qty: action === "inc" ? item.qty + 1 : Math.max(1, item.qty - 1) }
          : item
      )
    );
  };

  const handlePaymodeChange = (selectedOption) => {
    setFormData({
      ...formData,
      payment_mode: selectedOption ? selectedOption.value : "",
    });
  };

  const handleAddSelected = () => {
    const newItems = selectedProducts.map((p) => ({
      product_id: p.product_id || p.id,
      variant_id: null,
      product: p.product_name || "",
      qty: p.qty,
      unit_price: p.unit_price || 100,
      discount_percent: 0,
      tax_percent: 8,
      discount_amount: 0,
      tax_amount: 0,
      total: 0,
    }));

    setItemList((prev) => [...prev, ...newItems]);
    setSelectedProducts([]);
    setShowBulkModal(false);
    toast.success(`${newItems.length} products added!`);
    calculateTotals([...itemList, ...newItems]);
  };

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const updatedItems = [...itemList];
    updatedItems[index].image = file;
    setItemList(updatedItems);
  };

  const handleCancel = () => {
    if (window.confirm("Are you sure you want to cancel?")) {
      resetForm();
      toast.warning("Order cancelled!");
    }
  };

  const resetForm = () => {
    setFormData({
      bill_number: "",
      customer_id: "",
      customer_name: "",
      payment_mode: "",
      total_items: 0,
      total_qty: 0,
      sub_total: 0,
      discount_amount: 0,
      tax_amount: 0,
      grand_total: 0,
      payment_status: 1,
      customer_notes: "",
      terms_and_conditions: "",
      attached_file: null,
    });
    setItemList([]);
    setIsEditMode(false);
    setEditOrderId(null);
    setEditOrderStatus(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleAddClick = () => {
    resetForm();
    setIsEditMode(false);
    setEditOrderId(null);
    setEditOrderStatus(null);
    setErrors({});
    setShowStage("form");
  };

  const handleEditClick = async (item) => {
    try {
      setLoading(true);
      
      const res = await axios.get(`${var_api}veemart_instore_pos_billing/get-with-details/${item.id}`);
      const fullData = res.data;
      
      const customerId = fullData.customer_id ? String(fullData.customer_id) : "";
      
      setFormData({
        bill_number: fullData.bill_number || "",
        customer_id: customerId,
        customer_name: fullData.customer_name || "",
        payment_mode: fullData.payment_mode || "",
        total_items: fullData.total_items || 0,
        total_qty: parseFloat(fullData.total_qty) || 0,
        sub_total: parseFloat(fullData.sub_total) || 0,
        discount_amount: parseFloat(fullData.discount_amount) || 0,
        tax_amount: parseFloat(fullData.tax_amount) || 0,
        grand_total: parseFloat(fullData.grand_total) || 0,
        payment_status: fullData.payment_status || 1,
        customer_notes: fullData.remarks || "",
        terms_and_conditions: "",
        attached_file: null,
      });
      
      if (fullData.details && Array.isArray(fullData.details)) {
        const formattedItems = fullData.details.map(detail => ({
          id: detail.id,
          product_id: detail.product_id || null,
          variant_id: detail.variant_id || null,
          product: detail.product_name || `Product ${detail.product_id}`,
          qty: parseFloat(detail.qty) || 1,
          unit_price: parseFloat(detail.unit_price) || 0,
          discount_percent: parseFloat(detail.discount_percent) || 0,
          tax_percent: parseFloat(detail.tax_percent) || 8,
          discount_amount: 0,
          tax_amount: 0,
          total: parseFloat(detail.total) || 0,
        }));
        setItemList(formattedItems);
        calculateTotals(formattedItems);
      } else {
        setItemList([]);
      }
      
      setIsEditMode(true);
      setEditOrderId(item.id);
      setEditOrderStatus(fullData.order_status || 0);
      setErrors({});
      setShowStage("form");
    } catch (err) {
      console.error("Error fetching order details:", err);
      toast.error("Failed to fetch order details");
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = async (item) => {
    try {
      setLoading(true);
      
      const res = await axios.get(`${var_api}veemart_instore_pos_billing/get-with-details/${item.id}`);
      const fullData = res.data;
      
      setAdjustmentData(fullData);
      setShowAdjustDetails(true);
      setShowPDFView(true);
    } catch (err) {
      console.error("Error fetching order details:", err);
      toast.error("Failed to fetch order details");
    } finally {
      setLoading(false);
    }
  };

   const getOrderStatusBadge = (status) => {
    const statusConfig = {
      0: { label: "HOLD", color: "#6c757d" },
      1: { label: "CONFIRMED", color: "#17a2b8" },
      2: { label: "IN PROGRESS", color: "#ffc107" },
      3: { label: "OUT FOR DELIVERY", color: "#fd7e14" },
      4: { label: "DELIVERED", color: "#28a745" },
    };
    
    const config = statusConfig[status] || statusConfig[0];
    return (
      <span 
        className="badge" 
        style={{ backgroundColor: config.color, color: "#fff", fontSize: "11px", padding: "5px 10px" }}
      >
        {config.label}
      </span>
    );
  };

  const getNextStatusButton = (currentStatus) => {
    const statusFlow = {
      0: { next: 1, label: "Mark as Created", color: "#17a2b8" },
      1: { next: 2, label: "Mark as Confirmed", color: "#007bff" },
      2: { next: 3, label: "Mark as In Progress", color: "#ffc107" },
      3: { next: 4, label: "Mark as Out for Delivery", color: "#fd7e14" },
      4: { next: 5, label: "Mark as Delivered", color: "#28a745" },
    };
    
    return statusFlow[currentStatus] || null;
  };

  const handleUpdateOrderStatus = async (orderId, newStatus) => {
    try {
      setLoading(true);
      
      const payload = {
        id: orderId,
        order_status: newStatus
      };

      await axios.put(`${var_api}veemart_instore_pos_billing/update-order-status`, payload);
      
      toast.success("Order status updated successfully!");
      
      const res = await axios.get(`${var_api}veemart_instore_pos_billing/get-with-details/${orderId}`);
      setAdjustmentData(res.data);
      
      await fetchAdjustments();
    } catch (err) {
      console.error("Error updating order status:", err);
      toast.error("Failed to update order status");
    } finally {
      setLoading(false);
    }
  };

  const calculateTotals = (items) => {
    let totalQty = 0;
    let subTotal = 0;
    let totalDiscount = 0;
    let totalTax = 0;
    
    items.forEach((item) => {
      const qty = Number(item.qty) || 0;
      const unitPrice = Number(item.unit_price) || 0;
      const discountPercent = Number(item.discount_percent) || 0;
      const taxPercent = Number(item.tax_percent) || 0;

      const itemSubTotal = qty * unitPrice;
      const discountAmount = (itemSubTotal * discountPercent) / 100;
      const taxableAmount = itemSubTotal - discountAmount;
      const taxAmount = (taxableAmount * taxPercent) / 100;
      const itemTotal = taxableAmount + taxAmount;

      item.discount_amount = discountAmount.toFixed(2);
      item.tax_amount = taxAmount.toFixed(2);
      item.total = itemTotal.toFixed(2);

      totalQty += qty;
      subTotal += itemSubTotal;
      totalDiscount += discountAmount;
      totalTax += taxAmount;
    });

    const grandTotal = subTotal - totalDiscount + totalTax;

    setFormData((prev) => ({
      ...prev,
      total_items: items.length,
      total_qty: totalQty,
      sub_total: subTotal.toFixed(2),
      discount_amount: totalDiscount.toFixed(2),
      tax_amount: totalTax.toFixed(2),
      grand_total: grandTotal.toFixed(2),
    }));
  };

  const handleItemChange = (e, index) => {
    const { name, value } = e.target;
    const updatedItems = [...itemList];
    updatedItems[index][name] = value;
    setItemList(updatedItems);
    calculateTotals(updatedItems);
  };

  const handleAddRow = () => {
    setItemList([
      ...itemList,
      {
        product_id: null,
        variant_id: null,
        product: "",
        qty: 1,
        unit_price: 0,
        discount_percent: 0,
        tax_percent: 8,
        discount_amount: 0,
        tax_amount: 0,
        total: 0,
      },
    ]);
  };

  const handleDeleteItem = (index) => {
    const updated = [...itemList];
    updated.splice(index, 1);
    setItemList(updated);
    calculateTotals(updated);
  };

  const handleSubmit = async (e, isDraft = false) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.customer_name) newErrors.customer_name = "Customer name is required";
    if (!formData.payment_mode) newErrors.payment_mode = "Payment mode is required";
    if (itemList.length === 0) newErrors.items = "At least one item is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please fill all required fields");
      return;
    }

    setLoading(true);

    try {
      const now = new Date();
      const formattedDate = now.toLocaleString("en-GB", { hour12: false });
      const currentWarehouseId = warehouseId || 1;

      if (isEditMode && editOrderId) {
        // UPDATE MODE
        const payload = {
          id: editOrderId,
          customer_id: String(formData.customer_id || "1"),
          customer_name: formData.customer_name || "Customer 1",
          payment_mode: formData.payment_mode || "Cash",
          remarks: formData.customer_notes || "",
          billing_details: itemList.map((item) => ({
            id: item.id || null,
            warehouse_id: parseInt(currentWarehouseId),
            product_id: item.product_id || 14,
            variant_id: item.variant_id || null,
            qty: parseInt(item.qty) || 1,
            remarks: "",
            tax_percent: parseFloat(item.tax_percent) || 12,
            discount_percent: parseFloat(item.discount_percent) || 0,
            total: parseFloat(item.total) || null,
            unit_price: parseFloat(item.unit_price) || 0,
          })),
          discount_amount: parseFloat(formData.discount_amount) || 0,
          grand_total: parseFloat(formData.grand_total) || 0,
          sub_total: parseFloat(formData.sub_total) || 0,
          tax_amount: parseFloat(formData.tax_amount) || 0,
          total_items: parseInt(formData.total_items) || itemList.length,
          total_qty: parseInt(formData.total_qty) || 0,
        };

        console.log("Update Payload:", JSON.stringify(payload, null, 2));

        // Dummy update API call
        await axios.put(`${var_api}veemart_instore_pos_billing/update/${editOrderId}`, payload);

        toast.success("Order updated successfully!");
      } else {
        // CREATE MODE
        const payload = {
          warehouse_id: parseInt(currentWarehouseId),
          bill_number: formData.bill_number || `BILL-${Date.now()}`,
          bill_date_time: formattedDate,
          billing_details: itemList.map((item) => ({
            warehouse_id: parseInt(currentWarehouseId),
            product_id: 14,
            variant_id: item.variant_id || null,
            qty: parseInt(item.qty) || 1,
            remarks: "",
            tax_percent: parseFloat(item.tax_percent) || 12,
            discount_percent: parseFloat(item.discount_percent) || 0,
            total: parseFloat(item.total) || null,
            unit_price: parseFloat(item.unit_price) || 0,
          })),
          created_by: userName || "Admin",
          customer_id: String(formData.customer_id || "1"),
          customer_mobile: "",
          customer_name: formData.customer_name || "Customer 1",
          discount_amount: parseFloat(formData.discount_amount) || 0,
          grand_total: parseFloat(formData.grand_total) || 0,
          payment_mode: formData.payment_mode || "Cash",
          payment_status: "Paid",
          remarks: formData.customer_notes || "",
          sub_total: parseFloat(formData.sub_total) || 0,
          tax_amount: parseFloat(formData.tax_amount) || 0,
          total_items: parseInt(formData.total_items) || itemList.length,
          total_qty: parseInt(formData.total_qty) || 0,
          order_status: isDraft ? 0 : 1,
        };

        console.log("Final Payload:", JSON.stringify(payload, null, 2));

        const res = await axios.post(`${var_api}veemart_instore_pos_billing/post`, payload);

        toast.success(res?.data?.message || (isDraft ? "Order saved as draft!" : "Order created successfully!"));
      }
      
      await fetchAdjustments();
      setShowStage("table");
      resetForm();
    } catch (err) {
      console.error("Error saving order:", err);
      toast.error(err?.response?.data?.message || "Error occurred while saving order");
    } finally {
      setLoading(false);
    }
  };

  const handleConvertToAdjust = (e) => {
    if (itemList.length === 0) {
      toast.warning("Please add at least one item before saving as draft");
      return;
    }
    handleSubmit(e, true);
  };

  const handleDownloadPDF = async () => {
    if (!rightSectionRef.current) {
      toast.error("Content not found!");
      return;
    }

    const input = rightSectionRef.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("OrderDetails.pdf");
  };

  const handleSendEmail = async () => {
    if (!emailData.to) {
      toast.error("Please enter recipient email address");
      return;
    }

    if (!emailData.subject) {
      toast.error("Please enter email subject");
      return;
    }

    setSendingEmail(true);

    try {
      const orderDetails = selectedAdjustment || adjustmentData;
      
      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; background-color: #f4f4f4; margin: 0; padding: 0; }
            .container { max-width: 800px; margin: 20px auto; background: #fff; padding: 30px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); }
            .header { background: #007bff; color: white; padding: 30px; text-align: center; border-radius: 8px 8px 0 0; margin: -30px -30px 30px -30px; }
            .header h1 { margin: 0; font-size: 32px; }
            .order-info { background: #f8f9fa; padding: 20px; border-radius: 6px; margin-bottom: 30px; }
            .order-info p { margin: 8px 0; }
            .items-table { width: 100%; border-collapse: collapse; margin: 30px 0; }
            .items-table th { background: #343a40; color: white; padding: 12px; text-align: left; }
            .items-table td { padding: 12px; border-bottom: 1px solid #dee2e6; }
            .items-table tr:last-child td { border-bottom: none; }
            .total-section { text-align: right; margin-top: 30px; padding: 20px; background: #f8f9fa; border-radius: 6px; }
            .total-section p { margin: 8px 0; font-size: 16px; }
            .total-section .grand-total { font-size: 24px; font-weight: bold; color: #007bff; margin-top: 15px; padding-top: 15px; border-top: 2px solid #007bff; }
            .footer { text-align: center; margin-top: 40px; padding-top: 20px; border-top: 1px solid #dee2e6; color: #6c757d; }
            .status-badge { display: inline-block; padding: 6px 12px; border-radius: 4px; font-weight: bold; font-size: 12px; }
          </style>
        </head>
        <body>
          <div class='container'>
            <div class='header'>
              <h1>SALES ORDER</h1>
              <p style="margin: 10px 0 0 0; font-size: 18px;">Order# ${orderDetails.bill_number}</p>
            </div>
            
            <div class='order-info'>
              <p><strong>From:</strong> ${warehouseName || 'Store'}</p>
              <p><strong>Customer:</strong> ${orderDetails.customer_name}</p>
              <p><strong>Order Date:</strong> ${orderDetails.bill_date_time || orderDetails.created_at ? new Date(orderDetails.bill_date_time || orderDetails.created_at).toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB')}</p>
              <p><strong>Payment Mode:</strong> ${orderDetails.payment_mode}</p>
              <p><strong>Status:</strong> <span class="status-badge" style="background-color: ${
                orderDetails.order_status === 0 ? '#6c757d' :
                orderDetails.order_status === 1 ? '#17a2b8' :
                orderDetails.order_status === 2 ? '#007bff' :
                orderDetails.order_status === 3 ? '#ffc107' :
                orderDetails.order_status === 4 ? '#fd7e14' : '#28a745'
              }; color: #fff;">
                ${
                  orderDetails.order_status === 0 ? 'DRAFT' :
                  orderDetails.order_status === 1 ? 'CREATED' :
                  orderDetails.order_status === 2 ? 'CONFIRMED' :
                  orderDetails.order_status === 3 ? 'IN PROGRESS' :
                  orderDetails.order_status === 4 ? 'OUT FOR DELIVERY' : 'DELIVERED'
                }
              </span></p>
            </div>

            <h3 style="margin-bottom: 15px;">Order Items</h3>
            <table class='items-table'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item</th>
                  <th style="text-align: center;">Qty</th>
                  <th style="text-align: right;">Rate</th>
                  <th style="text-align: right;">Amount</th>
                </tr>
              </thead>
              <tbody>
                ${orderDetails.details && Array.isArray(orderDetails.details) && orderDetails.details.length > 0 
                  ? orderDetails.details.map((item, idx) => `
                    <tr>
                      <td>${idx + 1}</td>
                      <td><strong>${item.product_name || `Product ${item.product_id}`}</strong></td>
                      <td style="text-align: center;">${parseFloat(item.qty).toFixed(2)}</td>
                      <td style="text-align: right;">₹${parseFloat(item.unit_price || 0).toFixed(2)}</td>
                      <td style="text-align: right;">₹${parseFloat(item.total || 0).toFixed(2)}</td>
                    </tr>
                  `).join('')
                  : `
                    <tr>
                      <td>1</td>
                      <td><strong>Sample Product</strong></td>
                      <td style="text-align: center;">1.00</td>
                      <td style="text-align: right;">₹${orderDetails.grand_total}.00</td>
                      <td style="text-align: right;">₹${orderDetails.grand_total}.00</td>
                    </tr>
                  `
                }
              </tbody>
            </table>

            <div class='total-section'>
              <p><strong>Sub Total:</strong> ₹${parseFloat(orderDetails.sub_total || orderDetails.grand_total).toFixed(2)}</p>
              ${orderDetails.discount_amount && parseFloat(orderDetails.discount_amount) > 0 ? `<p><strong>Discount:</strong> -₹${parseFloat(orderDetails.discount_amount).toFixed(2)}</p>` : ''}
              ${orderDetails.tax_amount && parseFloat(orderDetails.tax_amount) > 0 ? `<p><strong>Tax:</strong> +₹${parseFloat(orderDetails.tax_amount).toFixed(2)}</p>` : ''}
              <p class='grand-total'><strong>Grand Total:</strong> ₹${parseFloat(orderDetails.grand_total).toFixed(2)}</p>
            </div>

            ${emailData.body ? `
              <div style="margin-top: 30px; padding: 20px; background: #f8f9fa; border-radius: 6px;">
                <h4 style="margin-top: 0;">Message:</h4>
                <p style="white-space: pre-wrap;">${emailData.body}</p>
              </div>
            ` : ''}

            <div class='footer'>
              <p>Thank you for your business!</p>
              <p style="margin: 5px 0;"><strong>${warehouseName || 'Store'}</strong></p>
              ${warehouseEmail ? `<p style="margin: 5px 0;">Email: ${warehouseEmail}</p>` : ''}
            </div>
          </div>
        </body>
        </html>
      `;

      const textContent = `
Sales Order from ${warehouseName || 'Store'}

Order Number: ${orderDetails.bill_number}
Customer: ${orderDetails.customer_name}
Date: ${orderDetails.bill_date_time || orderDetails.created_at ? new Date(orderDetails.bill_date_time || orderDetails.created_at).toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB')}
Payment Mode: ${orderDetails.payment_mode}

Grand Total: ₹${parseFloat(orderDetails.grand_total).toFixed(2)}

${emailData.body ? `\nMessage:\n${emailData.body}\n` : ''}

Thank you for your business!
${warehouseName || 'Store'}
${warehouseEmail ? `Email: ${warehouseEmail}` : ''}
      `;

      const payload = {
        to: emailData.to,
        subject: emailData.subject,
        html: htmlContent,
        text: textContent
      };

      const response = await axios.post(
        `${var_api}sa_veemart_admin/send-email`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      toast.success("Email sent successfully!");
      setShowEmailComposer(false);
      setShowAdjustDetails(true);
      
      setEmailData({
        from: warehouseEmail || "",
        to: "",
        subject: "Sales Order from Veemart POS",
        body: "",
      });
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error(error?.response?.data?.message || "Failed to send email. Please try again.");
    } finally {
      setSendingEmail(false);
    }
  };

  const handlePrint = () => {
    if (!rightSectionRef.current) {
      toast.error("Content not found!");
      return;
    }

    const printContent = rightSectionRef.current.innerHTML;
    const win = window.open("", "", "height=700,width=900");
    win.document.write("<html><head><title>Print</title></head><body>");
    win.document.write(printContent);
    win.document.write("</body></html>");
    win.document.close();
    win.print();
  };

  const filteredData = adjustments.filter((item) =>
    String(item.customer_name || "")
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Check if order can be fully edited (Draft or Created status only)
  const canFullyEdit = () => {
    return editOrderStatus === 0 || editOrderStatus === 1;
  };


  // Add these handler functions
const handlePrintBill = async (order) => {
  try {
    // Fetch bill details
    const billRes = await axios.get(
      `${var_api}veemart_instore_pos_billing/billing-detail/${order.id}`
    );
    
    if (billRes.status === 200) {
      // Use the print function from pos.js
      printBillReceipt(billRes.data);
    }
  } catch (error) {
    console.error("Failed to fetch bill details:", error);
    toast.error("Unable to print bill");
  }
};

// Extract the print logic into reusable functions (similar to pos.js)
const printBillReceipt = (billData) => {
  const printWindow = window.open('', '_blank');
  
  const printContent = `
  <!DOCTYPE html>
  <html>
  <head>
    <title>Receipt</title>
    <meta charset="utf-8" />
    <style>
      @page {
        size: 80mm auto;
        margin: 0;
        padding: 0;
      }
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      body {
        width: 80mm;
        font-family: Arial, sans-serif;
        font-size: 10px;
        padding: 5mm;
        line-height: 1.4;
        font-weight: normal;
      }
      
      .header {
        text-align: center;
        margin-bottom: 5px;
        padding-bottom: 5px;
      }
      .company-name {
        font-size: 16px;
        font-weight: 900;
        margin-bottom: 3px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
      }
      .company-address {
        font-size: 10px;
        margin-bottom: 2px;
        font-weight: 600;
        line-height: 1.3;
      }
      .contact-info {
        font-size: 9px;
        margin-bottom: 5px;
        font-weight: 600;
        color: #333;
      }
      
      .bill-info {
        margin-bottom: 10px;
        font-size: 11px;
      }
      .bill-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 3px;
      }
      
      .items-table {
        width: 100%;
        border-collapse: collapse;
        margin: 10px 0;
      }
      .items-table th {
        text-align: left;
        padding: 4px 2px;
        font-weight: 800;
        font-size: 11px;
        border-bottom: 2px solid #000;
        border-top: 2px solid #000;
      }
      .items-table td {
        padding: 5px 2px;
        font-size: 11px;
      }
      .item-name {
        width: 50%;
      }
      .item-qty {
        width: 20%;
        text-align: center;
      }
      .item-unit-price {
        width: 20%;
        text-align: center;
      }
      .item-amt {
        width: 30%;
        text-align: right;
        font-weight: 600;
      }
      
      .summary {
        font-size: 11px;
        margin: 10px 0;
        border-top: 2px solid #000;
        padding-top: 8px;
      }
      .summary-row {
        display: flex;
        justify-content: space-between;
        margin: 2px 0;
      }
      .total-row {
        display: flex;
        justify-content: space-between;
        font-weight: 900;
        margin: 8px 0;
        padding: 6px 0;
        font-size: 12px;
        border-top: 2px solid #000;
        border-bottom: 2px solid #000;
      }
      
      .payment {
        font-size: 11px;
        font-weight: 700;
        margin: 8px 0;
      }
      
      .footer {
        text-align: center;
        margin-top: 15px;
        padding-top: 8px;
        border-top: 1px dashed #000;
        font-size: 9px;
        font-weight: 600;
        color: #555;
      }
      
      .text-right {
        text-align: right;
      }
      .text-center {
        text-align: center;
      }
      .bold {
        font-weight: 800;
      }
    </style>
  </head>
  <body>
    <div class="header">
      <div class="company-name">ROYALS FISH PVT LTD</div>
      <div class="company-address">
        S USMAN ROAD, T. NAGAR,<br>
        CHENNAI, TAMIL NADU.
      </div>
      <div class="contact-info">
        PHONE : 044 258636222 
      </div>
    </div>
    
    <div class="bill-info">
      <div class="bill-row">
        <span>Bill #: <strong>#${billData.header.bill_number}</strong></span>
        <span>Pay: ${billData.header.payment_mode}</span>
      </div>
      <div class="bill-row">
        <span>Customer: <strong>#${billData.header.customer_name}</strong></span>
        <span>Mobile: ${billData.header.customer_mobile}</span>
      </div>
    </div>
    
    <table class="items-table">
      <thead>
        <tr>
          <th class="item-name">Item</th>
          <th class="item-qty">Qty</th>
          <th class="item-unit-price">U.Price</th>
          <th class="item-amt">Amt</th>
        </tr>
      </thead>
      <tbody>
        ${billData.details.map(item => `
          <tr>
            <td class="item-name">${item.product_name}</td>
            <td class="item-qty">${item.qty}</td>
            <td class="item-unit-price">${item.unit_price}</td>
            <td class="item-amt">₹${parseFloat(item.line_total).toFixed(2)}</td>
          </tr>
        `).join('')}
      </tbody>
    </table>
    
    <div class="summary">
      <div class="summary-row">
        <span>Sub Total</span>
        <span>${billData.details.length}</span>
        <span class="bold">₹${parseFloat(billData.header.sub_total).toFixed(2)}</span>
      </div>
      
      ${billData.header.cleaning_charge > 0 ? `
      <div class="summary-row">
        <span>Cleaning Charge</span>
        <span></span>
        <span class="bold">₹${parseFloat(billData.header.cleaning_charge).toFixed(2)}</span>
      </div>
      ` : ''}

      ${billData.header.delivery_charge > 0 ? `
      <div class="summary-row">
        <span>Delivery Charge</span>
        <span></span>
        <span class="bold">₹${parseFloat(billData.header.delivery_charge).toFixed(2)}</span>
      </div>
      ` : ''}
      
      ${billData.header.discount_amount > 0 ? `
      <div class="summary-row">
        <span>(-) Discount</span>
        <span></span>
        <span class="bold">₹${parseFloat(billData.header.discount_amount).toFixed(2)}</span>
      </div>
      ` : ''}
      
      <div class="total-row">
        <span>TOTAL</span>
        <span></span>
        <span>₹${parseFloat(billData.header.grand_total).toFixed(2)}</span>
      </div>
    </div>
    
    <div class="payment">
      <div class="summary-row">
        <span>Cash :</span>
        <span></span>
        <span>₹${parseFloat(billData.header.grand_total).toFixed(2)}</span>
      </div>
    </div>
    
    <div class="footer">
      Thank you for your visit! Please come again!
    </div>
    
    <script>
      window.onload = () => {
        setTimeout(() => {
          window.print();
          window.onafterprint = () => window.close();
        }, 100);
      }
    </script>
  </body>
  </html>`;
  
  printWindow.document.write(printContent);
  printWindow.document.close();
};



const handlePrintCuttingSlip = async (order) => {
  try {
    // Fetch bill details for cutting slip
    const billRes = await axios.get(
      `${var_api}veemart_instore_pos_billing/cutting-instructions/${order.id}`
    );
    
    if (billRes.status === 200 && billRes.data.length > 0) {
      // Transform API data to match print function structure
      const cuttingSlipData = transformCuttingData(billRes.data);
      
      // Use the cutting slip function from pos.js
      printCuttingSlip(cuttingSlipData);
    } else {
      toast.error("No cutting instructions found");
    }
  } catch (error) {
    console.error("Failed to fetch cutting slip details:", error);
    toast.error("Unable to print cutting slip");
  }
};

// Transform API response to match print function structure
const transformCuttingData = (apiData) => {
  if (!apiData || apiData.length === 0) return null;
  
  // Use first item for common bill details
  const firstItem = apiData[0];
  
  return {
    bill_number: firstItem.bill_number,
    date_time: new Date(firstItem.bill_date_time).toLocaleString(),
    customer_name: firstItem.customer_name,
    customer_mobile: firstItem.customer_mobile,
    items: apiData.map((item, index) => ({
      sno: index + 1,
      cutting_code: item.cutting_code,
      product_name: item.product_name,
      qty: item.cutting_qty,
      cutting_name: item.cutting_name,
      cutting_info: item.cutting_info || '',
      billing_qty: item.billing_qty,
      uom: 'KG' // Assuming unit is KG based on your data
    }))
  };
};

// Print function for cutting slip (called from modal)
const printCuttingSlip = (cuttingSlipData) => {
  if (!cuttingSlipData) return;
  
  const printWindow = window.open('', '_blank', 'width=800,height=600');
  
  const printContent = `
  <!DOCTYPE html>
  <html>
  <head>
    <title>Cutting Slip - ${cuttingSlipData.bill_number}</title>
    <style>
      @page {
        size: auto;
        margin: 10mm;
      }
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      body {
        font-family: Arial, sans-serif;
        font-size: 12px;
        line-height: 1.4;
        padding: 16px;
        background: #fff;
      }
      
      /* Modal-like container */
      .print-container {
        max-width: 100%;
        margin: 0 auto;
      }
      
      /* Header matching modal */
      .print-header {
        background: #fff3cd;
        border-bottom: 2px solid #ffb703;
        padding: 12px 16px;
        margin-bottom: 16px;
        border-radius: 4px;
      }
      
      .print-title {
        color: #333;
        font-weight: 800;
        font-size: 16px;
        margin: 0;
      }
      
      /* Company/Cutting Title */
      .company-title {
        text-align: center;
        margin-bottom: 16px;
        padding-bottom: 8px;
      }
      
      .cutting-title {
        font-weight: 800;
        font-size: 18px;
        margin-bottom: 4px;
        color: #000;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        text-decoration: underline;
        text-align: center;
      }
      
      /* Bill Info */
      .bill-info {
        margin-bottom: 12px;
        font-size: 11px;
        line-height: 1.6;
      }
      
      .bill-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        margin-bottom: 8px;
      }
      
      .bill-label {
        font-weight: 700;
        color: #333;
      }
      
      .bill-value {
        color: #d32f2f;
        font-weight: 700;
        margin-left: 4px;
      }
      
      /* Table Styling */
      .cutting-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
        font-size: 11px;
      }
      
      .cutting-table thead {
        background: #f8f9fa;
        border-top: 2px solid #000;
        border-bottom: 2px solid #000;
      }
      
      .cutting-table th {
        padding: 8px 6px;
        text-align: left;
        font-weight: 800;
        font-size: 11px;
      }
      
      .cutting-table td {
        padding: 7px 4px;
        vertical-align: top;
      }
      
      .sno-col {
        width: 8%;
        font-weight: 800;
        font-size: 13px;
        color: #d32f2f;
      }
      
      .code-col {
        width: 10%;
        font-size: 13px;
        font-weight: 800;
        color: #333;
      }
      
      .item-col {
        width: 32%;
      }
      
      .qty-col {
        width: 15%;
        text-align: center;
      }
      
      .instructions-col {
        width: 35%;
        font-size: 10px;
        color: #333;
        line-height: 1.4;
        font-weight: 700;
      }
      
      .qty-box {
        color: black;
        padding: 6px 10px;
        border-radius: 5px;
        font-weight: 800;
        font-size: 12px;
        display: inline-block;
      }
      
      /* Summary */
      .summary {
        margin-top: 3px;
        font-size: 11px;
        font-weight: 700;
      }
      
      .summary-row {
        display: flex;
        justify-content: space-between;
        padding: 6px 0;
        border-top: 2px solid #000;
      }
      
      /* Hide on print */
      @media print {
        .print-header {
          display: none !important;
        }
        .cutting-table th,
        .cutting-table td {
          border-color: #000 !important;
        }
        body {
          padding: 0;
        }
      }
      
      @media screen {
        .print-header {
          display: block;
        }
      }
    </style>
  </head>
  <body>
    <div class="print-container">
      <!-- Modal-like Header -->
      <div class="print-header hide-on-print">
        <div class="print-title">🔪 Cutting Instructions Slip</div>
      </div>
      
      <!-- Company/Cutting Title -->
      <div class="company-title">
        <div class="cutting-title">Cutting Instructions</div>
      </div>
      
      <!-- Bill Info -->
      <div class="bill-info">
        <div class="bill-row">
          <div style="flex: 1">
            <span class="bill-label">Bill No:</span>
            <span class="bill-value">${cuttingSlipData.bill_number}</span>
          </div>
          <div style="flex: 1; text-align: right">
            <span class="bill-label">Date & Time:</span>
            <span>${cuttingSlipData.date_time}</span>
          </div>
        </div>
        
        <div>
          <span class="bill-label">Customer Name:</span>
          <span class="bill-value">${cuttingSlipData.customer_name}</span>
        </div>
      </div>
      
      <!-- Table -->
      <table class="cutting-table">
        <thead>
          <tr>
            <th class="sno-col">S.No</th>
            <th class="code-col">Code</th>
            <th class="item-col">Item</th>
            <th class="qty-col">Qty</th>
            <th class="instructions-col">Instructions</th>
          </tr>
        </thead>
        <tbody>
          ${cuttingSlipData.items.map((item, idx) => `
            <tr>
              <td class="sno-col">${idx + 1}</td>
              <td class="code-col">${item.cutting_code || '-'}</td>
              <td class="item-col">
                <div style="font-weight: 700; font-size: 12px; color: #111; margin-bottom: 2px">
                  ${item.product_name}
                </div>
              </td>
              <td class="qty-col">
                <div class="qty-box">
                  ${item.qty} ${item.uom || 'KG'}
                </div>
              </td>
              <td class="instructions-col">
                ${item.cutting_info || '-'}
              </td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      
      <!-- Summary -->
      <div class="summary">
        <div class="summary-row">
          <div style="flex: 1">
            <span>Total Items:</span>
            <span style="margin-left: 4px">${cuttingSlipData.items.length}</span>
          </div>
          <div style="flex: 1; text-align: right">
            <span>Total Quantity:</span>
            <span style="margin-left: 4px">
              ${cuttingSlipData.items.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0).toFixed(2)} KG
            </span>
          </div>
        </div>
      </div>
      
      <!-- Additional summary if needed -->
      ${cuttingSlipData.items[0]?.billing_qty ? `
      <div class="summary" style="margin-top: 10px; border-top: none;">
        <div class="summary-row" style="border-top: none;">
          <div style="flex: 1">
            <span>Total Bill Quantity:</span>
            <span style="margin-left: 4px">${cuttingSlipData.items[0].billing_qty} KG</span>
          </div>
          <div style="flex: 1; text-align: right">
            <span>Remaining Quantity:</span>
            <span style="margin-left: 4px">
              ${(parseFloat(cuttingSlipData.items[0].billing_qty) - cuttingSlipData.items.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0)).toFixed(2)} KG
            </span>
          </div>
        </div>
      </div>
      ` : ''}
    </div>
    
    <script>
      window.onload = () => {
        setTimeout(() => {
          window.print();
          window.onafterprint = () => window.close();
        }, 100);
      }
    </script>
  </body>
  </html>`;
  
  printWindow.document.write(printContent);
  printWindow.document.close();
};

  return (
    <>
      {/* ====== EMPTY STATE ====== */}
      {showStage === "empty" && (
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ height: "70vh", textAlign: "center" }}
        >
          <h4 className="fw-bold mb-2">Start Managing Your Sales Activities!</h4>
          <p className="text-muted mb-4">
            View and manage all your sales done at the counters in your store and the orders placed
            online.
          </p>
          <Button variant="primary" size="lg" className="px-4 py-2" onClick={handleAddClick}>
            CREATE SALES ORDER
          </Button>
        </div>
      )}

      {/* ====== TABLE VIEW ====== */}
      {showStage === "table" && !showAdjustDetails && (
        <Card>
          <Card.Body>
            {initialLoading ? (
              <div className="text-center my-5">
                <div className="spinner-border text-primary" role="status"></div>
                <div>Loading data...</div>
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h5 className="fw-bold mb-1">{warehouseName || 'Warehouse'} Order List</h5>
                    <small className="text-muted">Manage all orders for this warehouse</small>
                  </div>
                  <div className="d-flex gap-2">
                    <input
                      type="text"
                      className="form-control w-auto"
                      placeholder="Search orders..."
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                    <Button variant="secondary" onClick={handleAddClick}>
                      Add
                    </Button>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        {tableHeaders.map((header, idx) => (
                          <th key={idx}>{header}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="text-center text-muted py-3">
                            No data found
                          </td>
                        </tr>
                      ) : (
                        paginatedData.map((item, idx) => (
                          <tr key={item.id}>
                            <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                            <td>
                              <span
                                onClick={() => handleViewDetails(item)}
                                style={{ 
                                  color: '#007bff',
                                  cursor: 'pointer',
                                  textDecoration: 'underline',
                                  fontWeight: '500'
                                }}
                              >
                                {item.bill_number || "N/A"}
                              </span>
                            </td>
                            <td>{item.customer_name}</td>
                            <td>{item.payment_mode}</td>
                            <td>{item.total_items}</td>
                            <td>{item.total_qty}</td>
                            <td>₹{item.grand_total}</td>
                            <td>
                              {getOrderStatusBadge(item.order_status || 0)}
                            </td>
                            <td>
                               {/* Print Bill Button */}
              <button
                className="btn btn-sm btn-success me-2"
                onClick={() => handlePrintBill(item)}
                title="Print Bill"
              >
                <i className="fas fa-receipt"></i>
              </button>
              
              {/* Print Cutting Slip Button */}
              <button
                className="btn btn-sm btn-warning me-2"
                onClick={() => handlePrintCuttingSlip(item)}
                title="Print Cutting Slip"
              >
                <i className="fas fa-cut"></i>
              </button>
                              <button
                                className="btn btn-sm btn-primary me-2"
                                onClick={() => handleEditClick(item)}
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      )}

      {/* ====== FORM VIEW ====== */}
      {showStage === "form" && !showAdjustDetails && (
        <Card className="shadow-sm border-0 rounded-3">
          <Card.Body>
            <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-2">
              <div className="d-flex align-items-center gap-3">
                <Button 
                  variant="outline-secondary" 
                  size="sm"
                  onClick={() => setShowStage("table")}
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  Back
                </Button>
                <h5 className="mb-0 fw-bold">
                  {isEditMode ? "✏️ Edit Sales Order" : "+ New Sales Order"}
                </h5>
              </div>
            </div>

            {/* Show Edit Restriction Alert */}
          
            {isEditMode && editOrderStatus !== 5 && !canFullyEdit() && (
              <div className="alert alert-warning mb-4" role="alert">
                <i className="fas fa-info-circle me-2"></i>
                <strong>Limited Edit Mode:</strong> This order status is "
                {editOrderStatus === 2
                  ? "CONFIRMED"
                  : editOrderStatus === 3
                  ? "IN PROGRESS"
                  : editOrderStatus === 4
                  ? "OUT FOR DELIVERY"
                  : ""}
                ".
                You can only edit: Payment Mode, Customer Address, Remarks, and reduce Item Quantities.
              </div>
            )}


            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Bill Number <small className="text-muted">(Auto-generated)</small>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="bill_number"
                      placeholder="Auto-generated"
                      value={formData.bill_number}
                      onChange={handleInputChange}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Customer <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      key={`customer-select-${formData.customer_id}`}
                      options={customerData.map((cust) => ({
                        value: String(cust.id),
                        label: cust.customer_name,
                      }))}
                      placeholder="Select or search customer..."
                      value={
                        formData.customer_id && formData.customer_name
                          ? {
                              value: String(formData.customer_id),
                              label: formData.customer_name,
                            }
                          : null
                      }
                      onChange={(selected) => {
                        if (selected) {
                          setFormData({
                            ...formData,
                            customer_id: selected.value,
                            customer_name: selected.label,
                          });
                        } else {
                          setFormData({
                            ...formData,
                            customer_id: "",
                            customer_name: "",
                          });
                        }
                      }}
                      isSearchable
                      isClearable
                      isDisabled={isEditMode && !canFullyEdit()}
                      closeMenuOnSelect={true}
                      menuShouldScrollIntoView={false}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: errors.customer_name ? "#dc3545" : "#ced4da",
                          borderRadius: "6px",
                          boxShadow: "none",
                          "&:hover": { borderColor: "#86b7fe" },
                        }),
                      }}
                    />
                    {errors.customer_name && (
                      <small className="text-danger">{errors.customer_name}</small>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Payment Mode <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={paymodeOptions}
                      value={
                        formData.payment_mode
                          ? { value: formData.payment_mode, label: formData.payment_mode }
                          : null
                      }
                      onChange={handlePaymodeChange}
                      isClearable
                      isSearchable
                      placeholder={loading ? "Loading..." : "Select payment mode"}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: "#ced4da",
                          borderRadius: "6px",
                          boxShadow: "none",
                          "&:hover": { borderColor: "#86b7fe" },
                        }),
                      }}
                    />
                    {errors.payment_mode && (
                      <small className="text-danger">{errors.payment_mode}</small>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Total Items (Auto-calculated)</Form.Label>
                    <Form.Control
                      type="number"
                      name="total_items"
                      value={formData.total_items}
                      readOnly
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Total Quantity (Auto-calculated)</Form.Label>
                    <Form.Control
                      type="number"
                      name="total_qty"
                      value={formData.total_qty}
                      readOnly
                      disabled
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Grand Total (₹) (Auto-calculated)</Form.Label>
                    <Form.Control
                      type="number"
                      name="grand_total"
                      value={formData.grand_total}
                      readOnly
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Item Table */}
              <Col md={12}>
                <h6 className="fw-bold mb-3">
                  Item Table <span className="text-danger">*</span>
                </h6>
                {errors.items && <small className="text-danger d-block mb-2">{errors.items}</small>}
                <Table bordered hover responsive>
                  <thead className="table-light">
                    <tr>
                      <th>Product</th>
                      <th>Qty</th>
                      <th>Unit Price</th>
                      <th>Discount %</th>
                      <th>Tax %</th>
                      <th>Total</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemList.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <Form.Control
                            type="text"
                            name="product"
                            value={item.product}
                            onChange={(e) => handleItemChange(e, index)}
                            placeholder="Product Name"
                            disabled={isEditMode && !canFullyEdit()}
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="number"
                            name="qty"
                            value={item.qty}
                            onChange={(e) => {
                              // In limited edit mode, only allow reducing quantity
                              if (isEditMode && !canFullyEdit()) {
                                const newQty = parseInt(e.target.value);
                                const originalQty = item.qty;
                                if (newQty <= originalQty) {
                                  handleItemChange(e, index);
                                } else {
                                  toast.warning("You can only reduce quantity in this order status");
                                }
                              } else {
                                handleItemChange(e, index);
                              }
                            }}
                            min="1"
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="number"
                            name="unit_price"
                            value={item.unit_price}
                            onChange={(e) => handleItemChange(e, index)}
                            min="0"
                            disabled={isEditMode && !canFullyEdit()}
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="number"
                            name="discount_percent"
                            value={item.discount_percent}
                            onChange={(e) => handleItemChange(e, index)}
                            min="0"
                            max="100"
                            disabled={isEditMode && !canFullyEdit()}
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="number"
                            name="tax_percent"
                            value={item.tax_percent}
                            onChange={(e) => handleItemChange(e, index)}
                            min="0"
                            disabled={isEditMode && !canFullyEdit()}
                          />
                        </td>
                        <td>
                          <Form.Control type="text" value={`₹${item.total}`} readOnly disabled />
                        </td>
                        <td>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDeleteItem(index)}
                            disabled={isEditMode && !canFullyEdit()}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {(!isEditMode || canFullyEdit()) && (
                  <div className="d-flex gap-3 mb-4">
                    <Button variant="outline-primary" onClick={handleAddRow}>
                      + Add New Row
                    </Button>
                    <Button variant="outline-success" onClick={handleBulkAdd}>
                      + Add Items in Bulk
                    </Button>
                  </div>
                )}
              </Col>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>Customer Notes / Remarks</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="customer_notes"
                      rows={3}
                      placeholder="Will be displayed on POS"
                      value={formData.customer_notes}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>Terms & Conditions</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="terms_and_conditions"
                      rows={3}
                      placeholder="Enter the terms & conditions"
                      value={formData.terms_and_conditions}
                      onChange={handleInputChange}
                      disabled={isEditMode && !canFullyEdit()}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Summary Section */}
              <Row className="mb-3">
                <Col md={12}>
                  <Card className="bg-light">
                    <Card.Body>
                      <Row>
                        <Col md={3}>
                          <strong>Sub Total:</strong> ₹{formData.sub_total}
                        </Col>
                        <Col md={3}>
                          <strong>Discount:</strong> ₹{formData.discount_amount}
                        </Col>
                        <Col md={3}>
                          <strong>Tax:</strong> ₹{formData.tax_amount}
                        </Col>
                        <Col md={3}>
                          <strong>Grand Total:</strong> ₹{formData.grand_total}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* Footer Buttons */}
             <div className="d-flex justify-content-end gap-3 mt-4 border-top pt-3">
  {isEditMode ? (
    <Button
      variant="primary"
      type="submit"
      disabled={loading || editOrderStatus === 5}  // ✔ Delivered → No Update
    >
      {loading ? "Updating..." : "Update Order"}
    </Button>
  ) : (
    <>
      <Button variant="primary" type="submit" disabled={loading}>
        {loading ? "Creating..." : "Create Order"}
      </Button>
      <Button variant="warning" onClick={handleConvertToAdjust}>
        Save as Draft
      </Button>
    </>
  )}

  <Button variant="danger" onClick={() => setShowCancelConfirm(true)}>
    Cancel
  </Button>
</div>

            </Form>
          </Card.Body>
        </Card>
      )}

      {/* Cancel Confirmation Modal */}
      <Modal show={showCancelConfirm} onHide={() => setShowCancelConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger fw-bold">
            <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
            Leave this page?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>If you leave, your unsaved changes will be discarded.</p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end">
          <Button
            variant="primary"
            className="px-4"
            style={{ backgroundColor: "#007bff", border: "none" }}
            onClick={() => setShowCancelConfirm(false)}
          >
            Stay Here
          </Button>
          <Button
            variant="light"
            className="px-4 text-dark border"
            style={{ backgroundColor: "#e0e0e0" }}
            onClick={() => {
              setShowCancelConfirm(false);
              setShowStage(adjustments.length > 0 ? "table" : "empty");
            }}
          >
            Leave & Discard Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Bulk Add Modal */}
      <Modal show={showBulkModal} onHide={() => setShowBulkModal(false)} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Items in Bulk</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            {/* LEFT SIDE - Product List */}
            <Col md={6} style={{ borderRight: "1px solid #ddd" }}>
              <h6 className="fw-bold mb-2">Products</h6>
              <Form.Control
                type="text"
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="mb-3"
              />

              <div style={{ maxHeight: "350px", overflowY: "auto" }}>
                {productData
                  .filter((p) => p.product_name?.toLowerCase().includes(searchTerm.toLowerCase()))
                  .map((p, index) => {
                    const isSelected = selectedProducts.some((sp) => sp.id === p.id);
                    return (
                      <div
                        key={p.id || index}
                        className={`d-flex justify-content-between align-items-center p-2 border-bottom ${
                          isSelected ? "bg-light" : ""
                        }`}
                      >
                        <span>{p.product_name}</span>
                        <Button
                          variant={isSelected ? "danger" : "outline-primary"}
                          size="sm"
                          onClick={() => toggleProductSelect(p)}
                        >
                          {isSelected ? "Remove" : <FaPlus />}
                        </Button>
                      </div>
                    );
                  })}
              </div>
            </Col>

            {/* RIGHT SIDE - Selected Items */}
            <Col md={6}>
              <h6 className="fw-bold mb-2">Selected Items (Qty)</h6>
              {selectedProducts.length === 0 ? (
                <p className="text-muted mt-2">No items selected</p>
              ) : (
                <div style={{ maxHeight: "350px", overflowY: "auto" }}>
                  {selectedProducts.map((item) => (
                    <div
                      key={item.id}
                      className="d-flex justify-content-between align-items-center border-bottom py-2"
                    >
                      <span>{item.product_name}</span>
                      <div className="d-flex align-items-center gap-2">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => updateQty(item.id, "dec")}
                        >
                          -
                        </Button>
                        <span>{item.qty}</span>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => updateQty(item.id, "inc")}
                        >
                          +
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </Modal.Body>

        {/* FOOTER BUTTONS */}
        <Modal.Footer>
          <Button
            onClick={handleAddSelected}
            style={{
              backgroundColor: "#007bff",
              borderColor: "#007bff",
              color: "#fff",
              fontWeight: "500",
            }}
          >
            Add Products
          </Button>
          <Button
            onClick={() => setShowBulkModal(false)}
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "#fff",
              fontWeight: "500",
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ADJUSTMENT DETAILS VIEW */}
      {showAdjustDetails && adjustmentData && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            minHeight: "100vh",
            background: "linear-gradient(to bottom right, #f8f9fa, #e9ecef)",
            padding: "20px",
          }}
        >
          <Card
            className="shadow-lg border-0"
            style={{
              width: "100%",
              maxWidth: "1400px",
              borderRadius: "16px",
              overflow: "hidden",
            }}
          >
            <Card.Body className="p-0">
              <Row className="g-0">
                {/* LEFT SIDEBAR */}
                <Col md={3} style={{ backgroundColor: "#f8f9fa", borderRight: "1px solid #dee2e6" }}>
                  <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h6 className="mb-0 fw-bold">All Sales Orders</h6>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => {
                          setShowAdjustDetails(false);
                          handleAddClick();
                        }}
                      >
                        +
                      </Button>
                    </div>

                    {/* Selected Order Card */}
                    <Card
                      className="mb-2"
                      style={{
                        backgroundColor: "#fff",
                        border: "2px solid #007bff",
                        borderRadius: "8px",
                      }}
                    >
                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div>
                            <h6 className="mb-1 fw-bold">{adjustmentData.customer_name}</h6>
                            <small className="text-muted">{adjustmentData.bill_number}</small>
                            <div className="mt-1">
                              <small className="text-muted">
                                {adjustmentData.bill_date_time || adjustmentData.created_at 
                                  ? new Date(adjustmentData.bill_date_time || adjustmentData.created_at).toLocaleDateString('en-GB')
                                  : "12 Nov 2025"}
                              </small>
                            </div>
                          </div>
                          <div className="text-end">
                            <h6 className="mb-0">₹{adjustmentData.grand_total}</h6>
                          </div>
                        </div>
                        {getOrderStatusBadge(adjustmentData.order_status || 0)}
                      </Card.Body>
                    </Card>

                    {/* Other Orders */}
                    {adjustments
                      .filter((item) => item.bill_number !== adjustmentData.bill_number)
                      .slice(0, 5)
                      .map((item) => (
                        <Card
                          key={item.id}
                          className="mb-2"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #dee2e6",
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleViewDetails(item)}
                        >
                          <Card.Body className="p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div>
                                <h6 className="mb-1">{item.customer_name}</h6>
                                <small className="text-muted">{item.bill_number}</small>
                                <div className="mt-1">
                                  <small className="text-muted">
                                    {item.bill_date_time || item.created_at 
                                      ? new Date(item.bill_date_time || item.created_at).toLocaleDateString('en-GB')
                                      : "12 Nov 2025"}
                                  </small>
                                </div>
                              </div>
                              <div className="text-end">
                                <h6 className="mb-0">₹{item.grand_total}</h6>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))}
                  </div>
                </Col>

                {/* RIGHT DETAILS PANEL */}
                <Col md={9}>
                  <div className="p-4">
                    {/* Action Bar */}
                    <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                      <div className="d-flex align-items-center gap-3">
                        <Button 
                          variant="outline-secondary" 
                          size="sm"
                          onClick={() => setShowAdjustDetails(false)}
                        >
                          <i className="fas fa-arrow-left me-2"></i>
                          Back
                        </Button>
                        <h4 className="mb-0 fw-bold">{adjustmentData.bill_number}</h4>
                      </div>
                      <div className="d-flex gap-2">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => {
                            setShowAdjustDetails(false);
                            handleEditClick(adjustmentData);
                          }}
                        >
                          <i className="fas fa-edit me-2"></i>
                          Edit
                        </Button>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => {
                            setSelectedAdjustment(adjustmentData);
                            setShowEmailComposer(true);
                            setShowAdjustDetails(false);
                          }}
                        >
                          <i className="fas fa-envelope me-2"></i>
                          Send Email
                        </Button>
                        <Dropdown>
                          <Dropdown.Toggle variant="outline-secondary" size="sm">
                            <i className="fas fa-file-pdf me-2"></i>
                            PDF/Print
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={handleDownloadPDF}>
                              <i className="fas fa-download me-2"></i>
                              Download PDF
                            </Dropdown.Item>
                            <Dropdown.Item onClick={handlePrint}>
                              <i className="fas fa-print me-2"></i>
                              Print
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => setShowAdjustDetails(false)}
                        >
                          <i className="fas fa-times me-2"></i>
                          Close
                        </Button>
                      </div>
                    </div>

                    {/* What's Next Banner */}
                    <div
                      className="alert d-flex justify-content-between align-items-center mb-4"
                      style={{ 
                        backgroundColor: "#e7f3ff", 
                        border: "1px solid #b3d9ff",
                        borderRadius: "8px"
                      }}
                    >
                      <div>
                        <i className="fas fa-lightbulb me-2" style={{ color: "#ff1493" }}></i>
                        <strong style={{ color: "#ff1493" }}>WHAT'S NEXT?</strong>{" "}
                        <span>
                          {
                            adjustmentData.order_status === 0 
                              ? "Update the order status to move it to the next stage."
                              : adjustmentData.order_status === 5
                              ? "This order has been delivered successfully!"
                              : "Update the order status to move it to the next stage."
                          }
                        </span>
                      </div>
                      <div className="d-flex gap-2">
                        {adjustmentData.order_status !== 5 && (
                          <>
                            <Button 
                              style={{
                                backgroundColor: "#dc3545",
                                borderColor: "#dc3545",
                                color: "#fff"
                              }}
                              size="sm"
                              onClick={() => {
                                setSelectedAdjustment(adjustmentData);
                                setShowEmailComposer(true);
                                setShowAdjustDetails(false);
                              }}
                            >
                              Send Sales Order
                            </Button>
                            {getNextStatusButton(adjustmentData.order_status) && (
                              <Button 
                                size="sm"
                                disabled={loading}
                                style={{
                                  backgroundColor: "#fff",
                                  borderColor: "#007bff",
                                  color: "#007bff"
                                }}
                                onClick={() => handleUpdateOrderStatus(
                                  adjustmentData.id, 
                                  getNextStatusButton(adjustmentData.order_status).next
                                )}
                              >
                                {loading ? "Updating..." : getNextStatusButton(adjustmentData.order_status).label}
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                    </div>

                    {/* Packages Section */}
                    <div className="mb-4">
                      <div
                        className="d-flex justify-content-between align-items-center p-3"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderRadius: "8px",
                          cursor: "pointer",
                        }}
                      >
                        <h6 className="mb-0 fw-bold">Packages</h6>
                        <i className="fas fa-chevron-right"></i>
                      </div>
                    </div>

                    {/* PDF View Toggle */}
                    <div className="d-flex justify-content-end mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={showPDFView}
                          onChange={(e) => setShowPDFView(e.target.checked)}
                        />
                        <label className="form-check-label">Show PDF View</label>
                      </div>
                    </div>

                    {/* PDF Content */}
                    {showPDFView && (
                      <div
                        ref={rightSectionRef}
                        className="position-relative d-flex justify-content-center"
                      >
                        <Card
                          className="shadow border-0 position-relative"
                          style={{
                            width: "100%",
                            maxWidth: "800px",
                            borderRadius: "12px",
                            backgroundColor: "#fff",
                          }}
                        >
                          {/* Draft Ribbon */}
                          <div
                            style={{
                              position: "absolute",
                              top: "20px",
                              left: "-30px",
                              backgroundColor: 
                                adjustmentData.order_status === 0 ? "#6c757d" :
                                adjustmentData.order_status === 1 ? "#17a2b8" :
                                adjustmentData.order_status === 2 ? "#007bff" :
                                adjustmentData.order_status === 3 ? "#ffc107" :
                                adjustmentData.order_status === 4 ? "#fd7e14" :
                                "#28a745",
                              color: "#fff",
                              transform: "rotate(-45deg)",
                              width: "150px",
                              textAlign: "center",
                              fontWeight: "600",
                              padding: "5px 0",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                              fontSize: "12px",
                            }}
                          >
                            {
                              adjustmentData.order_status === 0 ? "DRAFT" :
                              adjustmentData.order_status === 1 ? "CREATED" :
                              adjustmentData.order_status === 2 ? "CONFIRMED" :
                              adjustmentData.order_status === 3 ? "IN PROGRESS" :
                              adjustmentData.order_status === 4 ? "OUT FOR DELIVERY" :
                              "DELIVERED"
                            }
                          </div>

                          <Card.Body className="p-5">
                            {/* Header */}
                            <div className="text-center mb-5">
                              <h2 className="fw-bold" style={{ fontSize: "36px" }}>
                                SALES ORDER
                              </h2>
                              <p className="text-muted mb-2">
                                Sales Order# {adjustmentData.bill_number}
                              </p>
                              <div className="mb-0">
                                {getOrderStatusBadge(adjustmentData.order_status)}
                              </div>
                            </div>

                            {/* CHANGE 8: Updated Company Info to use warehouseName and warehouseEmail */}
                            <Row className="mb-5">
                              <Col md={6}>
                                <div className="mb-3">
                                  <h6 className="fw-bold mb-2">{warehouseName || 'Store'}</h6>
                                  <p className="mb-1">{warehouseAddress  || 'Store' }</p>
                                  <p className="mb-1">India</p>
                                  {/* <p className="mb-1">7598140169</p> */}
                                  <p className="mb-0">{warehouseEmail || 'prichal497@gmail.com'}</p>
                                </div>
                              </Col>
                              <Col md={6} className="text-end">
                                <div className="mb-3">
                                  <p className="mb-2">
                                    <strong>Order Date:</strong>{" "}
                                    {adjustmentData.bill_date_time || adjustmentData.created_at 
                                      ? new Date(adjustmentData.bill_date_time || adjustmentData.created_at).toLocaleDateString('en-GB') 
                                      : "12 Nov 2025"}
                                  </p>
                                </div>
                              </Col>
                            </Row>

                            <Row className="mb-5">
                              <Col md={12}>
                                <h6 className="fw-bold mb-2">Bill To</h6>
                                <p className="text-primary fw-bold mb-0">{adjustmentData.customer_name}</p>
                               <p className="text-primary mb-0">
                                {adjustmentData?.customer?.full_address || "--"}
                              </p>

                              <p className="text-primary mb-0">
                                {adjustmentData?.customer?.customer_mobile_whatsapp || "--"}
                              </p>

                                <p className="text-primary mb-0">{adjustmentData.customer_mobile}</p>
                                 <p className="text-primary mb-0">paymode : {adjustmentData.payment_mode}</p>
                              </Col>
                            </Row>

                            {/* Items Table */}
                            <div className="table-responsive mb-5">
                              <table className="table table-bordered">
                                <thead style={{ backgroundColor: "#e6eaefff", color: "#fff" }}>
                                  <tr>
                                    <th>#</th>
                                    <th>Item & Description</th>
                                    <th className="text-end">Qty</th>
                                    <th className="text-end">Rate</th>
                                    <th className="text-end">Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {adjustmentData.details &&
                                  Array.isArray(adjustmentData.details) &&
                                  adjustmentData.details.length > 0 ? (
                                    adjustmentData.details.map((item, idx) => (
                                      <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td>
                                          <div className="fw-bold">
                                            {item.product_name || `Product ${item.product_id}`}
                                          </div>
                                          <small className="text-muted">box</small>
                                        </td>
                                        <td className="text-end">
                                          {parseFloat(item.qty).toFixed(2)} <small>box</small>
                                        </td>
                                        <td className="text-end">₹{parseFloat(item.unit_price || 0).toFixed(2)}</td>
                                        <td className="text-end">₹{parseFloat(item.total || 0).toFixed(2)}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td>1</td>
                                      <td>
                                        <div className="fw-bold">Sample Product</div>
                                        <small className="text-muted">box</small>
                                      </td>
                                      <td className="text-end">
                                        1.00 <small>box</small>
                                      </td>
                                      <td className="text-end">₹{adjustmentData.grand_total}.00</td>
                                      <td className="text-end">₹{adjustmentData.grand_total}.00</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>

                            {/* Totals */}
                            <Row className="justify-content-end mb-5">
                              <Col md={6}>
                                <table className="table table-sm">
                                  <tbody>
                                    <tr>
                                      <td className="text-end border-0">
                                        <strong>Sub Total</strong>
                                      </td>
                                      <td className="text-end border-0">
                                        ₹{parseFloat(adjustmentData.sub_total || adjustmentData.grand_total).toFixed(2)}
                                      </td>
                                    </tr>

                                     {adjustmentData.cleaning_charge && parseFloat(adjustmentData.cleaning_charge) > 0 && (
                                      <tr>
                                        <td className="text-end border-0">
                                          <strong>Cleaning Charge</strong>
                                        </td>
                                        <td className="text-end border-0">
                                          +₹{parseFloat(adjustmentData.cleaning_charge).toFixed(2)}
                                        </td>
                                      </tr>
                                    )}

                                     {adjustmentData.delivery_charge && parseFloat(adjustmentData.delivery_charge) > 0 && (
                                      <tr>
                                        <td className="text-end border-0">
                                          <strong>Delivery Charge</strong>
                                        </td>
                                        <td className="text-end border-0">
                                          +₹{parseFloat(adjustmentData.delivery_charge).toFixed(2)}
                                        </td>
                                      </tr>
                                    )}
                                    {adjustmentData.discount_amount && parseFloat(adjustmentData.discount_amount) > 0 && (
                                      <tr>
                                        <td className="text-end border-0">
                                          <strong>Discount</strong>
                                        </td>
                                        <td className="text-end border-0">
                                          -₹{parseFloat(adjustmentData.discount_amount).toFixed(2)}
                                        </td>
                                      </tr>
                                    )}
                                    {/* {adjustmentData.tax_amount && parseFloat(adjustmentData.tax_amount) > 0 && (
                                      <tr>
                                        <td className="text-end border-0">
                                          <strong>Tax</strong>
                                        </td>
                                        <td className="text-end border-0">
                                          +₹{parseFloat(adjustmentData.tax_amount).toFixed(2)}
                                        </td>
                                      </tr>
                                    )} */}
                                    <tr>
                                      <td className="text-end border-0 pt-3">
                                        <h5 className="mb-0">
                                          <strong>Total</strong>
                                        </h5>
                                      </td>
                                      <td className="text-end border-0 pt-3">
                                        <h5 className="mb-0">
                                          <strong>₹{parseFloat(adjustmentData.grand_total).toFixed(2)}</strong>
                                        </h5>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </Col>
                            </Row>

                            {/* Signature */}
                            <div className="mt-5 pt-5 border-top">
                              <p className="mb-0">
                                <strong>Authorized Signature</strong>
                              </p>
                              <div
                                style={{
                                  borderBottom: "1px solid #000",
                                  width: "250px",
                                  marginTop: "40px",
                                }}
                              ></div>
                            </div>
                          </Card.Body>
                        </Card>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      )}

      {/* Email Composer */}
      {showEmailComposer && (
        <div
          style={{
            position: "fixed",
            bottom: "10px",
            right: "10px",
            width: "1200px",
            backgroundColor: "#fff",
            borderRadius: "10px 10px 0 0",
            boxShadow: "0 4px 25px rgba(0,0,0,0.25)",
            overflow: "hidden",
            zIndex: 1050,
            animation: "fadeInUp 0.3s ease",
            border: "1px solid #dee2e6",
          }}
        >
          {/* Header */}
          <div
            className="d-flex justify-content-between align-items-center px-3 py-2"
            style={{
              background: "#f2f6fc",
              borderBottom: "1px solid #dee2e6",
              cursor: "grab",
            }}
          >
            <span className="fw-semibold text-secondary">New Message</span>
            <div className="d-flex gap-2">
              <Button
                variant="light"
                size="sm"
                className="p-0 px-2 text-secondary border-0"
                onClick={() => {
                  setShowEmailComposer(false);
                  setShowAdjustDetails(true);
                }}
              >
                ✕
              </Button>
            </div>
          </div>

          {/* Body */}
          <div className="p-4">
            <Form>
              <Form.Group className="mb-3 d-flex align-items-center border-bottom pb-2">
                <Form.Label className="me-2 text-secondary mb-0" style={{ width: "70px" }}>
                  From
                </Form.Label>
                <Form.Control
                  type="email"
                  value={emailData.from}
                  onChange={(e) => setEmailData({ ...emailData, from: e.target.value })}
                  className="border-0 p-0"
                  style={{ boxShadow: "none", background: "transparent" }}
                  readOnly
                />
              </Form.Group>

              <Form.Group className="mb-3 d-flex align-items-center border-bottom pb-2">
                <Form.Label className="me-2 text-secondary mb-0" style={{ width: "70px" }}>
                  To
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Recipient"
                  value={emailData.to}
                  onChange={(e) => setEmailData({ ...emailData, to: e.target.value })}
                  className="border-0 p-0"
                  style={{ boxShadow: "none", background: "transparent" }}
                />
              </Form.Group>

              <Form.Group className="mb-3 d-flex align-items-center border-bottom pb-2">
                <Form.Label className="me-2 text-secondary mb-0" style={{ width: "70px" }}>
                  Subject
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Add a subject"
                  value={emailData.subject}
                  onChange={(e) => setEmailData({ ...emailData, subject: e.target.value })}
                  className="border-0 p-0"
                  style={{ boxShadow: "none", background: "transparent" }}
                />
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Control
                  as="textarea"
                  rows={12}
                  placeholder="Type your message..."
                  value={emailData.body}
                  onChange={(e) => setEmailData({ ...emailData, body: e.target.value })}
                  className="border-0"
                  style={{
                    resize: "none",
                    boxShadow: "none",
                    minHeight: "300px",
                  }}
                />
              </Form.Group>
            </Form>
          </div>

          {/* CHANGE 9: Updated Footer with handleSendEmail function and loading state */}
          <div
            className="d-flex justify-content-between align-items-center px-4 py-3"
            style={{
              borderTop: "1px solid #dee2e6",
              background: "#f9f9f9",
            }}
          >
            <div className="d-flex align-items-center gap-3">
              <Button
                variant="success"
                size="sm"
                className="fw-semibold px-4"
                onClick={handleSendEmail}
                disabled={sendingEmail}
              >
                {sendingEmail ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Sending...
                  </>
                ) : (
                  "Send"
                )}
              </Button>
            </div>
            <Button
              variant="light"
              size="sm"
              className="border-0 text-secondary"
              onClick={() => {
                setShowEmailComposer(false);
                setShowAdjustDetails(true);
              }}
              disabled={sendingEmail}
            >
              Discard
            </Button>
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default OrderList;